import { accordian } from "../../utils/accordian/accordian.js";
// import header from "../components/header.js";
import talkExpert from "../components/talk-expert.js";
import ourProducts from "./Home/our-products.js";
import tabs from "../../utils/tabs/tab.js";
import module from "./Home/fdcalculator.js";



document.addEventListener('DOMContentLoaded', function(e) {
//     setTimeout(function(e) {
        ourProducts({toggle: 'data-active', content: 'data-step', img: 'data-step-img'})
        accordian()
        // header()
        tabs()
       //  fdCalculator()
        talkExpert()

        module.fdCalculator()
        module.rangeSlider()

})